import { useSelector } from 'react-redux'

import importCSVSlice from './importCSV'

export const useImportCSVData = () => {
  const reducerState = useSelector((state) => state.importCSV)
  return reducerState
}

export const {
  setCSVFileData,
  changeHeader,
  resetCSVFileData,
  removeCSVDataRow,
  changeCSVData,
  setValidationInfo,
  setShowProgressBar,
  mappedFailedSubscribers,
  setActiveStep,
  setOptionsLanguages,
  setDialogEditCSVDataRow,
  setSendInvitation,
  setCancelImportDialog,
  setIsOpenDeleteCSVFileDialog,
  setIsOpenImportedSubscribersDialog,
  resetValidationInfo,
  setIsSocketConnected,
  setImportedSubscribersIds,
  setUploadingEnd,
  setUploadingProgress,
  setUploadingStart,
  setValidatingStart,
  setImportingStart,
  setImportingEnd,
  setInitilization,
  setValidationErrorMessage,
  setTags,
} = importCSVSlice.actions

export default importCSVSlice.reducer
